export default __webpack_public_path__ + "static/media/calendar-dark.3d8c7c81.svg";